import { z } from "zod";

// Conservative authoring limits chosen for better cross-device notification
// visibility. Backend accepts more, but longer copy is commonly truncated.
const TITLE_MAX = 50;
const BODY_MAX = 100;
const URL_MAX = 500;

// Reusable URL validator: valid URL or empty string (transformed to undefined).
const optionalUrl = z
  .string()
  .max(URL_MAX, { message: `URL must be ${URL_MAX} characters or less` })
  .url({ message: "Must be a valid URL" })
  .optional()
  .or(z.literal("").transform(() => undefined));

// Base content fields. The API also accepts partial updates via PATCH.
const baseSchema = {
  title: z
    .string()
    .min(1, { message: "Title is required" })
    .max(TITLE_MAX, {
      message: `Title must be ${TITLE_MAX} characters or less`,
    }),
  body: z
    .string()
    .min(1, { message: "Message body is required" })
    .max(BODY_MAX, {
      message: `Message must be ${BODY_MAX} characters or less`,
    }),
  deepLink: optionalUrl,
  imageUrl: optionalUrl,
};

export const createPushNotificationSchema = z.object(baseSchema);

export const updatePushNotificationSchema = z.object(baseSchema).partial();

export type TCreatePushNotificationFormValues = z.infer<
  typeof createPushNotificationSchema
>;
export type TUpdatePushNotificationFormValues = z.infer<
  typeof updatePushNotificationSchema
>;

// Constants for use in form UI (char counters, maxLength)
export const PUSH_NOTIFICATION_LIMITS = Object.freeze({
  TITLE_MAX,
  BODY_MAX,
  URL_MAX,
});
